import type { Ref } from "react";
import type { Class } from "@common/types/class";
import { Avatar, type AvatarSize } from "@design-system/Avatar/Avatar";
import { AvatarCopyId } from "./AvatarCopyId";

export interface ClassAvatarProps {
    class: Pick<Class, "label" | "iconColor">;
    size?: AvatarSize;
    /** The class's database ID, copied on right-click when `showDbIds` is on. */
    copyId?: string;
    className?: string;
    /** Set when the class's label is visible next to the avatar. */
    "aria-hidden"?: boolean;
    ref?: Ref<HTMLSpanElement>;
}

/** A class as a diamond with the initial of its label on its `iconColor`. */
export const ClassAvatar = ({
    class: classItem,
    size,
    copyId,
    className,
    "aria-hidden": isAriaHidden,
    ref,
}: Readonly<ClassAvatarProps>) => {
    const avatar = (
        <Avatar
            ref={ref}
            name={classItem.label}
            color={classItem.iconColor}
            shape="diamond"
            size={size}
            className={className}
            aria-hidden={isAriaHidden}
        />
    );

    return copyId === undefined ? (
        avatar
    ) : (
        <AvatarCopyId id={copyId} label="Class">
            {avatar}
        </AvatarCopyId>
    );
};
